import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';
import classNames from 'classnames';
import s from './index.module.less';
import InputArea from './InputArea';
import { InputPropsType } from './types';

const LargeNumberInput = ({
  className,
  enableErrorStyle,
  incrementButton,
  decrementButton,
  inputValue,
  input,
  loading,
  disabled,
}: InputPropsType) => {
  const inputStyle = {
    input: classNames(s.largeInput),
    group: classNames(s.groupLarge, enableErrorStyle && s.error),
  };

  return (
    <div className={className}>
      <Input.Group compact className={inputStyle.group}>
        <Button
          size="large"
          icon={<MinusOutlined />}
          {...decrementButton}
          disabled={disabled}
          className={classNames(s.button, s.decrement)}
          data-test="decrease"
        />

        <InputArea
          value={inputValue}
          className={inputStyle.input}
          loading={loading}
          input={input}
          disabled={disabled}
          dataTest="large-number-input"
        />

        <Button
          size="large"
          icon={<PlusOutlined />}
          {...incrementButton}
          disabled={disabled}
          className={classNames(s.button, s.increment)}
          data-test="increase"
        />
      </Input.Group>
    </div>
  );
};

export default LargeNumberInput;
